import React from 'react';
import { Earth, HeartHandshake } from 'lucide-react';
import { useLanguage } from '../../assets/js/LanguageContext';
import SectionEyebrow from '../common/SectionEyebrow';
import IconTile from '../common/IconTile';

const AboutUs_0 = () => {
  const { t } = useLanguage();

  return (
    <>
      <section className="section-band">
        <div className="section-band__inner tp-about-split">
          <div className="tp-about-split__copy">
            <h1 className="tp-sr-only">{t('aboutus_title')}</h1>
            <div aria-hidden="true">
              <SectionEyebrow>{t('aboutus_title')}</SectionEyebrow>
            </div>
            <p className="tp-about-statement">{t('aboutus_intro')}</p>
          </div>
          <div className="tp-about-split__media">
            <IconTile accent="#7C3AED" icon={<HeartHandshake size="1em" strokeWidth={1.25} />} />
          </div>
        </div>
      </section>

      <section className="section-band">
        <div className="section-band__inner tp-about-split tp-about-split--reverse">
          <div className="tp-about-split__copy">
            <SectionEyebrow>{t('aboutus_vision_title')}</SectionEyebrow>
            <p className="tp-about-statement">
              {t('aboutus_vision_text1')}{' '}
              <span className="tp-about-accent">{t('aboutus_vision_highlight')}</span>{' '}
              {t('aboutus_vision_text2')}
            </p>
          </div>
          <div className="tp-about-split__media">
            <IconTile
              accent="#0D9488"
              icon={<Earth size="1em" strokeWidth={1.25} />}
              caption={t('aboutus_ods_alt')}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default AboutUs_0;
